// Normaliza el `detail` de error de la API (string, arreglo de errores de validación FastAPI,
// u objeto) a un mensaje legible para el operador.
//
// PURO (Fase 0 · dominio compartido Web/Native): sin navegador, UI, React, red ni storage.
// Movido desde lib/api.js (que ahora re-exporta desde aquí). Comportamiento idéntico.
export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}
